import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { hasAccessIssue } from '../utils/collabSpaceErrorCheck';
import loc from 'owa-localize';
import { attachmentPolicyInformationBlockedAccess } from 'owa-locstrings/lib/strings/attachmentpolicy.locstring.json';
import { fluidLinkFailedCallout } from './CollabSpace.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib/Icon';

const styles = require('./ErrorInfoBar.scss');

export interface ErrorInfoBarProps {
    viewStateId: string;
}

export default observer(function ErrorInfoBar(props: ErrorInfoBarProps) {
    return (
        <div className={styles.accessIssueInfoBar}>
            <Icon className={styles.infoBarIcon} iconName={ControlIcons.Info} />
            {hasAccessIssue()
                ? loc(attachmentPolicyInformationBlockedAccess)
                : loc(fluidLinkFailedCallout)}
        </div>
    );
});
